"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ButtonCell - Composant bouton responsive
 * La navigation interne est gérée par le CellWrapper parent
 */const ButtonCell = ({
  text,
  link_to,
  action_log,
  styles_properties = {},
  className = '',
  style = {},
  disabled = false,
  ...rest
}) => {
  // Convertir les propriétés de style en CSS
  const computedStyle = {
    backgroundColor: styles_properties.background_color || '#007bff',
    color: styles_properties.text_color || '#ffffff',
    fontSize: styles_properties.text_size ? `${styles_properties.text_size}px` : undefined,
    fontFamily: styles_properties.text_font,
    borderRadius: styles_properties.border_radius ? `${styles_properties.border_radius}px` : '4px',
    borderColor: styles_properties.border_color,
    borderWidth: styles_properties.border_width ? `${styles_properties.border_width}px` : undefined,
    borderStyle: styles_properties.border_style || (styles_properties.border_width ? 'solid' : 'none'),
    padding: styles_properties.padding ? `${styles_properties.padding}px` : undefined,
    opacity: styles_properties.opacity,
    textAlign: styles_properties.text_align || 'center',
    width: '100%',
    height: '100%',
    cursor: link_to && !disabled ? 'pointer' : disabled ? 'not-allowed' : 'default',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...style
  };
  const buttonClasses = ['button-cell', disabled && 'button-cell--disabled', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: buttonClasses,
    style: computedStyle,
    "data-action-log": action_log,
    children: text
  });
};
var _default = exports.default = ButtonCell;